import { SagaIterator } from "redux-saga";
import { put, takeLatest, call } from "redux-saga/effects";
import { Alert } from "react-native";
import { setIsUserReady } from "~/state/user/actions";
import { loadInitialProgress } from "~/state/content-progress";
import { deleteAllDownloads, resetFlamelinkData } from "~/state/flamelink";
import { handleGetFlamelinkData } from "~/state/flamelink/sagas";
import { getRecentAppVersion } from "~/utils/app-version";
import { APP_VERSION } from "~/constants";
import { getMemoryData } from "~/utils/ram-info";
import { isWeb } from "~/utils/platform";
import { formatMessage } from "~/utils/translation";

import { renderBubbles, splashScreenFinishedLoading } from "./slice";
import { UserReadyAction } from "./types";
import { getWalkthrough } from "../tutorial/actions";

import { messages } from "./intl";
export function* handleStartLoading(): SagaIterator {
  yield put(getWalkthrough());
  yield put(renderBubbles());
  // Temporary fix for the issue with downloads for the apps being upgraded to Expo v49
  // Delete all downloads on the pre v49 builds
  const currentAppVersion = yield call(getRecentAppVersion);
  if (!currentAppVersion) {
    yield put(deleteAllDownloads());
  }
  // Reset the content cache after the app upgrade
  if (currentAppVersion !== APP_VERSION) {
    yield call(handleGetFlamelinkData);
  }
}

export function* startupSaga() {
  yield takeLatest(splashScreenFinishedLoading.type, handleStartLoading);
}

export function* checkDeviceMemory(): SagaIterator {
  if (isWeb) {
    return;
  }
  const memoryData = yield call(getMemoryData);
  if (memoryData?.isMemoryLow) {
    yield call(
      Alert.alert,
      formatMessage(messages.lowMemory),
      formatMessage(messages.lowMemoryDescription)
    );
  }
}

// Call those functions whenever we get a valid authenticated user
export function* handleIsUserReady({
  payload: { userId },
}: UserReadyAction): SagaIterator {
  yield put(loadInitialProgress({ userId }));
  yield call(checkDeviceMemory);
}

export function* isUserReadySaga() {
  yield takeLatest(setIsUserReady.type, handleIsUserReady);
}
